import { isCappedToday, type DayCounts } from './frequency.js';

/**
 * Auth state a creative is aimed at. Optional on the wire: rows created before
 * the column existed carry nothing and must keep behaving as 'both'.
 */
export type DisplayContext = 'before_login' | 'after_login' | 'both';

export interface PopupItem {
  id: string;
  name: string;
  imageUrl: string;
  linkUrl: string | null;
  displayContext?: DisplayContext | null;
  maxShowsPerDay?: number | null;
  priority: number;
}

/** 'both' is the fallback for anything unrecognised — never hide by accident. */
export function matchesDisplayContext(
  value: DisplayContext | null | undefined,
  authed: boolean,
): boolean {
  if (value === 'before_login') return !authed;
  if (value === 'after_login') return authed;
  return true;
}

/**
 * Which popups the lobby should show, in order. Seen ids (this browser session)
 * are skipped; anything that has used up its per-day allowance on this device is
 * skipped too.
 */
export function selectPopupsToShow(
  items: PopupItem[],
  opts: { authed: boolean; seenIds: string[]; dayCounts?: DayCounts },
): PopupItem[] {
  const seen = new Set(opts.seenIds);
  const dayCounts = opts.dayCounts;
  return items
    .filter((p) => matchesDisplayContext(p.displayContext, opts.authed))
    .filter((p) => !seen.has(p.id))
    .filter((p) => !dayCounts || !isCappedToday(dayCounts, p.id, p.maxShowsPerDay))
    .sort((a, b) => b.priority - a.priority);
}
